import { useQuery } from '@tanstack/react-query';
import { apiClient } from './client';
import { DaDataSuggestResponse } from './types';

/**
 * Получение предложений адресов от DaData
 * @param query - Строка поиска адреса
 * @returns Promise с предложениями
 */
export const fetchDaDataSuggestAddress = async (query: string): Promise<DaDataSuggestResponse> => {
  const response = await apiClient.get('/public/dadata/suggest/address', {
    params: { query },
  });
  return response.data;
};

/**
 * Hook для получения предложений адресов от DaData
 * @param query - Строка поиска адреса
 * @param enabled - Флаг активности запроса
 */
export const useFetchDaDataSuggestAddress = (query: string, enabled = true) => {
  return useQuery({
    queryKey: ['dadata-suggest-address', query],
    queryFn: () => fetchDaDataSuggestAddress(query),
    enabled: enabled && query.length >= 5,
    staleTime: 5 * 60 * 1000, // 5 минут
  });
};
